import { useModuleConfigOption } from '../../config/ClientConfigModule';

/**
 * Hook per verificare se mostrare la Tipologia dei Richiedenti per le Domande
 *
 */
export function useConfigRecipientEnabled() {
  const enabled = useModuleConfigOption('procedure', 'enableRecipients');
  return enabled?.value == 'true';
}
